import { render, staticRenderFns } from "./boxCom.vue?vue&type=template&id=13a50db5&scoped=true&"
import script from "./boxCom.vue?vue&type=script&lang=ts&"
export * from "./boxCom.vue?vue&type=script&lang=ts&"
import style0 from "./boxCom.vue?vue&type=style&index=0&id=13a50db5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a50db5",
  null
  
)

export default component.exports